/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitMicroAuthVerificationAmountRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'
import {SubmitMicroAuthVerificationAmountResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/MicroAuthVerification.pb'


export const submitMicroAuthVerificationAmount = (request:SubmitMicroAuthVerificationAmountRequest, options?: CashRequestOptions) => post<SubmitMicroAuthVerificationAmountRequest, SubmitMicroAuthVerificationAmountResponse>("/2.0/cash/submit-micro-auth-verification-amount", request, {...options, rejectOnError: true })